import React from "react";
function NotFoundPage() {
  return <div className="404">page not found</div>;
}
export default NotFoundPage;
